import React from 'react';
import { Alert, Text } from '@gjensidige/builders-components'

import { useAppDispatch, useAppSelector } from '../hooks/appHooks';
import { updatePlusPacketSelection } from '../store/slices/offerSlice';
import InsurancePackage from '../components/InsurancePackage/InsurancePackage';
import { Package } from '../interfaces/Types';
import { AppConstants } from '../utils/AppConstants';
import { InsuranceHelper } from '../utils/InsuranceHelper';
import { TextHelper } from '../utils/TextHelper';

interface PlusPacketProps {
  plusPacketData: Package[];
}
export const PlusPacketContainer: React.FC<any> = (props: PlusPacketProps) => {
  const dispatch = useAppDispatch();
  const updateTileSelection = (selectedTile: any) => {
    if (selectedTile.isEnabled) {
      dispatch(updatePlusPacketSelection(selectedTile));
    }
  };
  const productName = useAppSelector(
    (state) => state.insurance.offer.productName
  );
  const additionalPackageHeader =
    TextHelper.getAdditionalPackageHeader(productName);
  const renderPackageDisabledInfo = (
    isEnabled: boolean,
    disabledMessage: string
  ) => {
    return (
      <div className="mt-2 information-alert">
        <Alert
          severity="informative"
          variant="outlined"
        >
          <Text size="body"
            dangerouslySetInnerHTML={{
              __html: disabledMessage || AppConstants.getAppText('webshop.plusPacket.disableMessage')
            }}
          ></Text>
        </Alert>
      </div>
    );
  };
  return (
    <>
      <div className="mt-5 mb-3 align-center-lg">
        {additionalPackageHeader && (
          <Text size="large">{additionalPackageHeader}</Text>
        )}
      </div>
      {props.plusPacketData.map((packageItem: Package, index: number) => {
        if (!InsuranceHelper.isEmptyObject(packageItem)) {
          const priceHeaderInfo = TextHelper.getPackageHeaderLabels(
            productName,
            packageItem,
            []
          );

          return (
            <div key={index}>
              {InsuranceHelper.shouldDispayPlusPackage(
                productName,
                packageItem
              ) && (
                <div className={`pb-3`}>
                  <div
                    className={`${
                      !packageItem.isEnabled
                        ? 'disable-pluspacket disabled-tile'
                        : ''
                    }`}
                  >
                    <InsurancePackage
                      updateTileSelection={updateTileSelection}
                      data={packageItem}
                      priceLabel={priceHeaderInfo.priceLabel}
                      oldPriceLabel={priceHeaderInfo.oldPriceLabel}
                      packageTitle={priceHeaderInfo.packageTitle}
                      additionalInfos={priceHeaderInfo.packageInfos}
                    />
                  </div>
                  {!packageItem.isEnabled && 
                    renderPackageDisabledInfo(
                      packageItem.isEnabled,
                      packageItem.disabledMessage
                    )}  
                </div>
              )}
            </div>
          );
        }
      })}
    </>
  );
};
